import axios from 'axios';
import { getToken } from 'utils/token';

const deleteFaq = async ({ id }: { id: any }) => {
    const { data } = await axios.delete(`faqs/${id}`, {
        headers: { Authorization: getToken() },
    });
    return data;
};

export default deleteFaq;
